/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartManufacturerResponse
 */
export interface PartManufacturerResponse {
    /**
     * 
     * @type {number}
     * @memberof PartManufacturerResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PartManufacturerResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PartManufacturerResponse
     */
    description?: string;
}

/**
 * Check if a given object implements the PartManufacturerResponse interface.
 */
export function instanceOfPartManufacturerResponse(value: object): value is PartManufacturerResponse {
    return true;
}

export function PartManufacturerResponseFromJSON(json: any): PartManufacturerResponse {
    return PartManufacturerResponseFromJSONTyped(json, false);
}

export function PartManufacturerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartManufacturerResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function PartManufacturerResponseToJSON(json: any): PartManufacturerResponse {
    return PartManufacturerResponseToJSONTyped(json, false);
}

export function PartManufacturerResponseToJSONTyped(value?: PartManufacturerResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
    };
}

